import * as signalR from "@microsoft/signalr";
import { ErrorTemplateBuilder } from "../../infrastructure/error-template-builder";
import { authService } from "./auth-service";

export class SignalRAuMigrationService {
  public setAuMigrationConnectionEvents(connection: signalR.HubConnection) {
    connection.on("aumigration", async (message: any) => {
      try {
          await authService.logout();
      } catch (e) {
        console.error(
          ErrorTemplateBuilder.getCatchText(
            "SignalRAuMigrationService.aumigration",
            e,
          ),
        );
      }
    });
  }
}
